import React from "react";
import { PageHeader } from "@shared/ui/pageHeader";
import { Tabs } from "@shared/ui/tabs";
import { ResourceTypeList } from "./resources/type/list/List";
import { ResourceSubtypeList } from "./resources/sub-type/list/List";
import { ManufacturerTab } from "./Manufacturer&Models/tabs/Manufacturer";
import { ModelsTab } from "./Manufacturer&Models/tabs/Models";
import { ReadMethodsTab } from "./MeterReadFormat/tabs/ReadMethodsTab";
import { ReadFormatTab } from "./MeterReadFormat/tabs/ReadFormatTab";
import { ConditionStatusTab } from "./conditions/tabs/ConditionStatus";
import { ConditionReasonsTab } from "./conditions/tabs/ConditionReasons";
import { WarehouseList } from "./warehouse/list/List";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";

export function SettingsLanding() {
  usePageViewTimer({ pageName: "MX Meter Reading Settings" });

  const urlMapping = {
    resources: "resources",
    manufacturerModels: "manufacturer-models",
    readFormat: "read-format",
    conditions: "conditions",
    warehouse: "warehouse",
  };

  const tabComponents = {
    resources: {
      label: "Resources",
      component: <div className="hidden" />, // Radix tabs primitive needs a component placeholder
      subTabs: {
        type: {
          label: "Resource Type",
          component: <ResourceTypeList />,
        },
        subtype: {
          label: "Resource Sub Type",
          component: <ResourceSubtypeList />,
        },
      },
      subTabsUrlMapping: {
        type: "type",
        subtype: "subtype",
      },
      subTabsListClassName: "grid w-full grid-cols-2",
    },
    manufacturerModels: {
      label: "Manufacturer & Models",
      component: <div className="hidden" />,
      subTabs: {
        manufacturer: {
          label: "Manufacturer",
          component: <ManufacturerTab />,
        },
        models: {
          label: "Models",
          component: <ModelsTab />,
        },
      },
      subTabsUrlMapping: {
        manufacturer: "manufacturer",
        models: "models",
      },
      subTabsListClassName: "grid w-full grid-cols-2 mb-6",
    },
    readFormat: {
      label: "Read Format",
      component: <div className="hidden" />,
      subTabs: {
        methods: {
          label: "Read Methods",
          component: <ReadMethodsTab />,
        },
        format: {
          label: "Read Format",
          component: <ReadFormatTab />,
        },
      },
      subTabsUrlMapping: {
        methods: "methods",
        format: "format",
      },
      subTabsListClassName: "grid w-full grid-cols-2 mb-6",
    },
    conditions: {
      label: "Conditions",
      component: <div className="hidden" />,
      subTabs: {
        status: {
          label: "Condition Status",
          component: <ConditionStatusTab />,
        },
        reason: {
          label: "Condition Reason",
          component: <ConditionReasonsTab />,
        },
      },
      subTabsUrlMapping: {
        status: "status",
        reason: "reason",
      },
      subTabsListClassName: "grid w-full grid-cols-2",
    },
    warehouse: {
      label: "Warehouse",
      component: <WarehouseList />,
    },
  };

  return (
    <div className="p-4 space-y-6">
      <PageHeader
        title="Meter Reading Settings"
        description="Configure resources, manufacturer models, read formats, conditions, and warehouses."
      />

      <Tabs
        defaultValue="resources"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-5"
        idPrefix="mx-settings-tab"
        level={0}
      />
    </div>
  );
}

export default SettingsLanding;
